// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
// Utilities
import { compositeKeyFromStringArray } from "@ms/uno-utilities/lib/local/StringUtilities";
import moment from "moment";
export class ClearAccessTokenAction extends TypedAction(ActionType.ClearAccessToken) {
    loggingData() {
        return {
            scopes: compositeKeyFromStringArray(this.scopes)
        };
    }
    constructor(scopes){
        super(), this.scopes = scopes;
    }
}
export class FetchAccessTokenAction extends TypedAction(ActionType.FetchAccessToken) {
    loggingData() {
        return {
            actionId: this.actionId,
            scopes: compositeKeyFromStringArray(this.scopes)
        };
    }
    constructor(actionId, scopes, claims){
        super(), this.actionId = actionId, this.scopes = scopes, this.claims = claims, this.isTrackingEnabled = true;
    }
}
export class FetchAccessTokenFailedAction extends TypedAction(ActionType.FetchAccessTokenFailed) {
    loggingData() {
        return {
            actionId: this.actionId,
            scopes: compositeKeyFromStringArray(this.scopes)
        };
    }
    constructor(actionId, scopes, claims, error){
        super(), this.actionId = actionId, this.scopes = scopes, this.claims = claims, this.error = error, this.isTrackingEnabled = true;
    }
}
export class FetchAccessTokenSucceededAction extends TypedAction(ActionType.FetchAccessTokenSucceeded) {
    loggingData() {
        return {
            actionId: this.actionId,
            scopes: compositeKeyFromStringArray(this.scopes),
            expiry: this.expiry ? moment(this.expiry).toISOString() : "null"
        };
    }
    constructor(actionId, scopes, accessToken, expiry, claims){
        super(), this.actionId = actionId, this.scopes = scopes, this.accessToken = accessToken, this.expiry = expiry, this.claims = claims, this.isTrackingEnabled = true;
    }
}
